import { EvaluationType, FilterKeys, GroupType, ReportForAssessment } from '@schooly/api';

export const reportToMarkbookFilters = (
  detail: ReportForAssessment,
  fallbackDate: [string, string],
): Partial<Record<FilterKeys, unknown>> => {
  const areaOfLearningIds = detail.areas_of_learning
    .map((aol) => aol.id)
    .filter((id): id is string => Boolean(id));

  const groupTypes: GroupType[] = [
    GroupType.Subject,
    ...(detail.with_tutor_feedback ? [GroupType.TutorGroup] : []),
  ];

  const dateRange: [string, string] = detail.scheduled_publish_date
    ? [detail.scheduled_publish_date, detail.scheduled_publish_date]
    : fallbackDate;

  return {
    [FilterKeys.Assessment]: detail.assessments.map((a) => a.id),
    [FilterKeys.AgeGroup]: detail.age_groups.map((g) => g.id),
    [FilterKeys.Subject]: detail.subjects.map((s) => s.id),
    [FilterKeys.AreaOfLearning]: areaOfLearningIds,
    [FilterKeys.GroupTypes]: groupTypes,
    [FilterKeys.EvaluationType]: detail.with_tutor_feedback ? [EvaluationType.TutorFeedback] : [],
    [FilterKeys.Date]: dateRange,
    [FilterKeys.Group]: [],
  };
};
